import React from 'react'

export default function AddPlusIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.30233 0.961373C6.30233 0.518264 5.9431 0.159047 5.5 0.159047C5.0569 0.159047 4.69767 0.518254 4.69767 0.961373V4.69767L0.969289 4.69757C0.52617 4.69757 0.166963 5.0568 0.166953 5.49989C0.166953 5.9431 0.52617 6.30222 0.969278 6.30222L4.69767 6.30233V10.0386C4.69767 10.4817 5.0568 10.8409 5.5 10.8409C5.9431 10.8409 6.30233 10.4817 6.30233 10.0386V6.30233H10.0465C10.4896 6.30233 10.8488 5.9431 10.8488 5.5C10.8488 5.0569 10.4896 4.69767 10.0465 4.69767H6.30233V0.961373Z" fill="white" />
        </svg>
    )
}
